import axios from "axios";

/**
 * Feature Flag Service for RTDB (Firebase Realtime Database) vs Legacy (Socket.IO + REST).
 * Controlled via query parameter: ?ff_rtdb=true or ?ff_rtdb=false
 * Persisted in localStorage ('ff_rtdb').
 * Defaults to false (Legacy mode) if unset.
 */

export function initFeatureFlags() {
  if (typeof window === "undefined") return;

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const ffParam = urlParams.get("ff_rtdb");

    if (ffParam !== null) {
      const normalized = ffParam.trim().toLowerCase();
      if (normalized === "true" || normalized === "1") {
        window.localStorage.setItem("ff_rtdb", "true");
      } else if (normalized === "false" || normalized === "0") {
        window.localStorage.setItem("ff_rtdb", "false");
      }
    }
  } catch (e) {
    console.warn("Error initializing feature flags:", e);
  }

  // Set default header in axios for backend coordination.
  // El nombre va con guion medio a proposito: nginx descarta por defecto los
  // headers que tienen guion bajo (underscores_in_headers off), asi que
  // "ff_rtdb" nunca llegaba al backend en los ambientes desplegados. Laravel
  // normaliza el guion bajo a medio al leerlo, asi que header("ff_rtdb")
  // del lado del backend sigue funcionando sin cambios.
  const enabled = isRtdbEnabled();
  axios.defaults.headers.common["ff-rtdb"] = enabled ? "true" : "false";
}

export function isRtdbEnabled() {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem("ff_rtdb") === "true";
  } catch (e) {
    return false;
  }
}

export default {
  init: initFeatureFlags,
  isRtdbEnabled,
};
